const HOMEPAGE_SEARCH = {
  id: 'homePageHeroSearch',
  searchIcon: 'search',
  segmentLocation: 'homepage search',
  resultsId: 'homepageHeroResults',
};

export default HOMEPAGE_SEARCH;
